const PhoneIcon = props => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="#4079F5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.3333 0.673293L4.66659 0.666626C3.93325 0.666626 3.33325 1.26663 3.33325 1.99996V14C3.33325 14.7333 3.93325 15.3333 4.66659 15.3333H11.3333C12.0666 15.3333 12.6666 14.7333 12.6666 14V1.99996C12.6666 1.26663 12.0666 0.673293 11.3333 0.673293ZM11.3333 12.6666H4.66659V3.33329H11.3333V12.6666Z" />
  </svg>
)

export default PhoneIcon
